"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingContractorDescriptorEnum = void 0;
/**
 * Типы сущностей, используемых для идентификации контрагентов в биллинге
 *
 * @see https://git.onclass.tech/onclass/lingo2-billing/-/blob/master/src/billing-api/billing-api-contractor/types/dtos/billing-api-contractor.dto.ts
 */
var BillingContractorDescriptorEnum;
(function (BillingContractorDescriptorEnum) {
  BillingContractorDescriptorEnum["account"] = "account";
  BillingContractorDescriptorEnum["school"] = "school";
})(BillingContractorDescriptorEnum = exports.BillingContractorDescriptorEnum || (exports.BillingContractorDescriptorEnum = {}));
